import styled from 'styled-components'
import { Mkt03responsiveWidth } from '.';

const TermsAgreeWrap = styled.div<{ borderRadius: string }>`
  ${Mkt03responsiveWidth};

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 4px;
  margin: 0 auto 16px auto;
`


const AllTermsContainer = styled.div<{ active: boolean; checkColor: string }>`
  display: flex;
  align-items: center;
  gap: 10px;
  flex: 1 0 0;

  p {
    color: #666666;
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: 24px;
  }
`
const EachTermsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  align-self: stretch;
`

const EachTermsItems = styled.div`
  display: flex;
  height: 26px;
  padding: 10px 8px;
  align-items: center;
  gap: 4px;
  align-self: stretch;

  p {
    color: #666666;
    font-family: ${({ theme }) => theme.fontFamily};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 18px;
  }
`

export {
  TermsAgreeWrap,
  AllTermsContainer,
  EachTermsContainer,
  EachTermsItems,
}
